module.exports = {"attributes":{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 4.25C4.58579 4.25 4.25 4.58579 4.25 5C4.25 5.41421 4.58579 5.75 5 5.75H13.1893L4.46967 14.4697C4.17678 14.7626 4.17678 15.2374 4.46967 15.5303C4.76256 15.8232 5.23744 15.8232 5.53033 15.5303L14.25 6.81066V15C14.25 15.4142 14.5858 15.75 15 15.75C15.4142 15.75 15.75 15.4142 15.75 15V5C15.75 4.58579 15.4142 4.25 15 4.25H5Z\" fill=\"currentColor\"/>"}
const React = require('react');

function svgLoader(svg) {
	const { viewBox, width, height } = svg.attributes;

	// eslint-disable-next-line react/display-name
	return function (props) {
		return React.createElement(
			'svg',
			Object.assign(
				{
					dangerouslySetInnerHTML: { __html: svg.content },
					fill: 'currentColor',
					height,
					viewBox,
					width,
				},
				props,
			),
		);
	};
}

module.exports = svgLoader(module.exports);
